import { ProgressCreateDialogComponent } from './progress-create-dialog/progress-create-dialog.component';
import { ProgressScheduleAdjustDialogComponent } from './progress-schedule-adjust-dialog/progress-schedule-adjust-dialog.component';
import { ProgressScreeningRequestNotifyDialogComponent } from './progress-screening-request-notify-dialog/progress-screening-request-notify-dialog.component';
import { ProgressSubScreeningRequestNotifyDialogComponent } from './progress-sub-screening-request-notify-dialog/progress-sub-screening-request-notify-dialog.component';
import { ProgressSubScreeningScheduleAdjustDialogComponent } from './progress-sub-screening-schedule-adjust-dialog/progress-sub-screening-schedule-adjust-dialog.component';
import { ProgressSubScreeningStartDialogComponent } from './progress-sub-screening-start-dialog/progress-sub-screening-start-dialog.component';
import { ProgressSearchComponent } from './progress-search/progress-search.component';

export * from './progress-create-dialog/progress-create-dialog.component';
export * from './progress-schedule-adjust-dialog/progress-schedule-adjust-dialog.component';
export * from './progress-screening-request-notify-dialog/progress-screening-request-notify-dialog.component';
export * from './progress-sub-screening-request-notify-dialog/progress-sub-screening-request-notify-dialog.component';
export * from './progress-sub-screening-schedule-adjust-dialog/progress-sub-screening-schedule-adjust-dialog.component';
export * from './progress-sub-screening-start-dialog/progress-sub-screening-start-dialog.component';
export * from './progress-search/progress-search.component';

export const PROGRESS_COMPONENTS = [ProgressSearchComponent];

export const PROGRESS_DIALOG_COMPONENTS = [
  ProgressCreateDialogComponent,
  ProgressScheduleAdjustDialogComponent,
  ProgressScreeningRequestNotifyDialogComponent,
  ProgressSubScreeningRequestNotifyDialogComponent,
  ProgressSubScreeningScheduleAdjustDialogComponent,
  ProgressSubScreeningStartDialogComponent
];
